import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gas-icon-notifications',
  templateUrl: './gas-icon-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasIconNotificationComponent { }
